module.exports = __webpack_public_path__ + "static/template_options_year-d209ce719191d18ea2e33028b9f333be.png";